export const adminShellBackgroundSx = {
  minHeight: '100vh',
  background:
    'radial-gradient(circle at top left, rgba(25, 118, 210, 0.12), transparent 28%), radial-gradient(circle at 85% 10%, rgba(15, 118, 110, 0.1), transparent 22%), linear-gradient(180deg, #f6f8fc 0%, #eef2f7 100%)',
};

export const adminTopbarSx = {
  borderBottom: '1px solid rgba(15, 23, 42, 0.08)',
  bgcolor: 'rgba(248, 250, 252, 0.88)',
  backdropFilter: 'blur(18px)',
  boxShadow: '0 10px 30px rgba(15, 23, 42, 0.05)',
};

export const adminDrawerPaperSx = {
  background: 'linear-gradient(180deg, #fbfdff 0%, #f1f5f9 100%)',
  borderRight: '1px solid rgba(15, 23, 42, 0.08)',
  boxShadow: '18px 0 40px rgba(15, 23, 42, 0.05)',
};

export const adminDrawerHeaderSx = {
  position: 'relative',
  px: 2.5,
  py: 3,
  color: '#16324f',
  background:
    'radial-gradient(circle at top right, rgba(14, 165, 233, 0.18), transparent 35%), linear-gradient(135deg, rgba(255,255,255,0.96) 0%, rgba(237, 245, 255, 0.96) 100%)',
  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderBottom: '1px solid rgba(15, 23, 42, 0.08)',
    pointerEvents: 'none',
  },
};

export const adminHeroSx = {
  position: 'relative',
  overflow: 'hidden',
  p: { xs: 3, md: 4 },
  borderRadius: 5,
  border: '1px solid rgba(15, 23, 42, 0.08)',
  background:
    'linear-gradient(145deg, rgba(255,255,255,0.98) 0%, rgba(238, 245, 255, 0.96) 52%, rgba(233, 250, 247, 0.94) 100%)',
  boxShadow: '0 24px 50px rgba(15, 23, 42, 0.08)',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: -70,
    right: -60,
    width: 220,
    height: 220,
    borderRadius: '50%',
    background: 'rgba(59, 130, 246, 0.12)',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: -80,
    left: -30,
    width: 180,
    height: 180,
    borderRadius: '50%',
    background: 'rgba(20, 184, 166, 0.1)',
  },
};

export const adminSummaryCardSx = {
  height: '100%',
  borderRadius: 4,
  border: '1px solid rgba(15, 23, 42, 0.08)',
  background: 'rgba(255, 255, 255, 0.92)',
  boxShadow: '0 18px 36px rgba(15, 23, 42, 0.05)',
  backdropFilter: 'blur(14px)',
};

export const adminContentCardSx = {
  borderRadius: 4,
  border: '1px solid rgba(15, 23, 42, 0.08)',
  background: 'rgba(255, 255, 255, 0.94)',
  boxShadow: '0 18px 38px rgba(15, 23, 42, 0.06)',
};

export const adminActionCardSx = {
  ...adminContentCardSx,
  transition: 'transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 24px 46px rgba(15, 23, 42, 0.08)',
    borderColor: 'rgba(37, 99, 235, 0.16)',
  },
};

export const adminSoftChipSx = {
  alignSelf: 'flex-start',
  bgcolor: 'rgba(255,255,255,0.85)',
  color: '#0f3d66',
  borderColor: 'rgba(37, 99, 235, 0.16)',
  fontWeight: 700,
};

export const adminTableCardSx = {
  ...adminContentCardSx,
  overflow: 'hidden',
};

export const adminMetricIconSx = (background: string, color: string) => ({
  width: 48,
  height: 48,
  borderRadius: 3,
  display: 'grid',
  placeItems: 'center',
  bgcolor: background,
  color,
});

export const adminDialogPaperSx = {
  borderRadius: 4,
  border: '1px solid rgba(15, 23, 42, 0.08)',
  boxShadow: '0 28px 60px rgba(15, 23, 42, 0.16)',
};
